// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".major-search-year {\n  display: flex;\n  justify-content: space-between;\n}\n", "",{"version":3,"sources":["webpack://src/container/AuxiliaryManagement/index.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;AACF","sourcesContent":[".major-search-year {\n  display: flex;\n  justify-content: space-between;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
